import { useState } from "react";
import { createPortal } from "react-dom";
import { Film } from "lucide-react";

export function MirrorCover({ mirror }) {
  const [failed, setFailed] = useState([]);
  const [open, setOpen] = useState(false);
  const links = mirror.links || [];
  const provider = link => `${link.host_name || ""} ${link.host_domain || ""}`.toLowerCase();
  const sources = [...links.filter(l => /\bdood/.test(provider(l))),
    ...links.filter(l => /\bvoe\b/.test(provider(l)))];
  const source = sources.find(l => l.thumbnail && !failed.includes(l.thumbnail));
  const thumb = source?.thumbnail;
  const onError = () => setFailed(previous => [...new Set([...previous, thumb])]);
  if (!thumb) return <div className="w-28 h-16 rounded-md bg-surface border border-border shrink-0 flex items-center justify-center"><Film size={20} className="text-muted-foreground" /></div>;
  return <>
    <button type="button" className="shrink-0 rounded-md cursor-zoom-in focus-visible:ring-2 focus-visible:ring-brand"
      data-testid={`cover-${mirror.id}`} aria-label={`Vorschaubild von ${mirror.title} vergrößern`}
      onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)} onBlur={() => setOpen(false)} onKeyDown={e => { if (e.key === "Escape") setOpen(false); }}>
      <img src={thumb} alt="" className="w-28 h-16 rounded-md object-cover border border-border" onError={onError}/>
    </button>
    {open && createPortal(<div role="tooltip" className="pointer-events-none fixed inset-0 z-[100] flex items-center justify-center p-6">
      <div className="rounded-xl border border-border bg-card p-2 shadow-2xl">
        <img src={thumb} alt={`Vorschau: ${mirror.title}`} onError={onError}
          style={{width:"min(900px, 85vw)",maxHeight:"75vh",objectFit:"contain"}}
          className="rounded-lg bg-black"/>
        <p className="text-xs text-muted-foreground px-2 pt-2">{mirror.title} · {source.host_name || "Vorschaubild"}</p>
      </div>
    </div>, document.body)}
  </>;
}
